import React from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const ButtonLink = props => (
 <Link to={props.to}>
   {props.text} <FontAwesomeIcon icon={["fab", props.icon]} size={'2x'}/>
 </Link>
)

export const ButtonLinkSimp = props => (
  <Link to={props.to}>
    {props.text} <FontAwesomeIcon icon={props.icon} size={'2x'}/>
  </Link>
 )